export default __webpack_public_path__ + "static/media/Telugu_dm_1.e9bd5a51.mp3";